const CACHE_PREFIX = 'bart_cl_';

export const getCachedData = (key) => {
  try {
    const raw = sessionStorage.getItem(CACHE_PREFIX + key);
    if (!raw) return null;
    const { data, expiry } = JSON.parse(raw);
    if (Date.now() > expiry) {
      sessionStorage.removeItem(CACHE_PREFIX + key);
      return null;
    }
    return data;
  } catch {
    return null;
  }
};

export const setCachedData = (key, data, ttlMinutes = 15) => {
  try {
    const entry = {
      data,
      expiry: Date.now() + ttlMinutes * 60 * 1000
    };
    const json = JSON.stringify(entry);
    // Skip caching if this single entry would exceed 2MB (leave room for other cache entries)
    if (json.length > 2 * 1024 * 1024) return;
    sessionStorage.setItem(CACHE_PREFIX + key, json);
  } catch (e) {
    console.warn("Cache write failed for key:", key, e);
  }
};

export const clearCachedData = (key) => {
  sessionStorage.removeItem(CACHE_PREFIX + key);
};

export const clearAllChangeLogCache = () => {
  const keysToRemove = [];
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith(CACHE_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((k) => sessionStorage.removeItem(k));
};
